<app-navigation></app-navigation>
<app-login></app-login>
<router-outlet></router-outlet>
<app-footer></app-footer>
